import type { RunStatus } from "../../api/client";

export function RunStep({ run }: { run: RunStatus | null }) {
  return (
    <section className="flow-panel run-panel" aria-live="polite">
      <span className="spinner" aria-hidden="true" />
      <span className="eyebrow">第 3 步</span>
      <h2>固定 Workflow 正在运行</h2>
      <p>无 Agent 规划、无模型调用、无外部业务写入。页面会自动读取耐久运行状态。</p>
      <div className="run-meta">
        <span>运行 ID <code>{run?.id ?? "正在创建"}</code></span>
        <span>状态 <strong>{run?.state ?? "queued"}</strong></span>
        <span>尝试次数 <strong>{run?.attempt_count ?? 0}</strong></span>
      </div>
    </section>
  );
}
